if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.navPrev = this.querySelector('.product-media-modal__nav--prev');
        this.navNext = this.querySelector('.product-media-modal__nav--next');
        this.counter = this.querySelector('.product-media-modal__counter');
        this.currentIndex = 0;
        this.mediaItems = [];

        if (this.navPrev) {
          this.navPrev.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigate(-1);
          });
          this.navPrev.addEventListener('pointerup', (e) => e.stopPropagation());
        }
        if (this.navNext) {
          this.navNext.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigate(1);
          });
          this.navNext.addEventListener('pointerup', (e) => e.stopPropagation());
        }

        /* Stop the counter from closing the modal too */
        if (this.counter) {
          this.counter.addEventListener('pointerup', (e) => e.stopPropagation());
        }

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.navigate(-1);
          if (e.key === 'ArrowRight') this.navigate(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getVisibleMediaItems() {
        return Array.from(
          this.querySelectorAll('.product-media-modal__content > [data-media-id]')
        ).filter((el) => {
          return !el.classList.contains('product__media-item--variant') || el.style.display !== 'none';
        });
      }

      showActiveMedia() {
        this.mediaItems = this.getVisibleMediaItems();
        const openedMediaId = this.openedBy.getAttribute('data-media-id');

        // Find the index of the clicked image
        this.currentIndex = this.mediaItems.findIndex(
          (item) => item.dataset.mediaId === openedMediaId
        );
        if (this.currentIndex === -1) this.currentIndex = 0;

        this.showMediaAtIndex(this.currentIndex);
      }

      showMediaAtIndex(index) {
        this.mediaItems.forEach((item) => item.classList.remove('active'));

        const activeMedia = this.mediaItems[index];
        if (!activeMedia) return;

        activeMedia.classList.add('active');

        // Load deferred media if needed
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateCounter();
        this.updateNavVisibility();
      }

      navigate(direction) {
        const newIndex = this.currentIndex + direction;
        if (newIndex < 0 || newIndex >= this.mediaItems.length) return;
        this.currentIndex = newIndex;
        this.showMediaAtIndex(this.currentIndex);
      }

      updateCounter() {
        if (this.counter && this.mediaItems.length > 1) {
          this.counter.textContent = `${this.currentIndex + 1} / ${this.mediaItems.length}`;
          this.counter.style.display = '';
        } else if (this.counter) {
          this.counter.style.display = 'none';
        }
      }

      updateNavVisibility() {
        if (this.mediaItems.length <= 1) {
          if (this.navPrev) this.navPrev.style.display = 'none';
          if (this.navNext) this.navNext.style.display = 'none';
          return;
        }
        if (this.navPrev) this.navPrev.style.opacity = this.currentIndex === 0 ? '0.3' : '1';
        if (this.navNext) this.navNext.style.opacity = this.currentIndex === this.mediaItems.length - 1 ? '0.3' : '1';
      }
    }
  );
}
